import { DesignProp, GeneralProp } from "../PropCategories";
import { backgroundColor } from "./backgroundColor";
import { borderColor } from "./borderColor";
import { borderRadius } from "./borderRadius";
import { borderWidth } from "./borderWidth";
import { color } from "./color";
import { fontSize } from "./fontSize";
import { fontStyle } from "./fontStyle";
import { fontWeight } from "./fontWeight";
import { lineHeight } from "./lineHeight";
import { textAlign } from "./textAlign";
import { textDecoration } from "./textDecoration";
import { textTransform } from "./textTransform";

export const defaultButtonState = {
  name: "Default state",
  nameI18n: "builder_ui.prop_type.styles.default",
  category: [DesignProp, GeneralProp],
  prop: "styles",
  type: "other",
  defaultValue: {
    backgroundColor: {
      ...backgroundColor,
    },
    borderColor: {
      ...borderColor,
    },
    borderRadius: {
      ...borderRadius,
    },
    borderWidth: {
      ...borderWidth,
    },
    color: {
      ...color,
    },
    fontSize: {
      ...fontSize,
    },
    fontStyle: {
      ...fontStyle,
    },
    fontWeight: {
      ...fontWeight,
    },
    lineHeight: {
      ...lineHeight,
    },
    textAlign: {
      ...textAlign,
    },
    textDecoration: {
      ...textDecoration,
    },
    textTransform: {
      ...textTransform,
    },
  },
} as const;

export const hoverButtonState = {
  name: "Hover state",
  nameI18n: "builder_ui.prop_type.styles.hover",
  category: [DesignProp, GeneralProp],
  prop: "styles",
  type: "other",
  defaultValue: {
    backgroundColor: {
      ...backgroundColor,
    },
    borderColor: {
      ...borderColor,
    },
    borderRadius: {
      ...borderRadius,
    },
    borderWidth: {
      ...borderWidth,
    },
    color: {
      ...color,
    },
    fontSize: {
      ...fontSize,
    },
    fontStyle: {
      ...fontStyle,
    },
    fontWeight: {
      ...fontWeight,
    },
    lineHeight: {
      ...lineHeight,
    },
    textAlign: {
      ...textAlign,
    },
    textDecoration: {
      ...textDecoration,
    },
    textTransform: {
      ...textTransform,
    },
  },
} as const;
